import { cn } from '@/lib/utils';
import Perk from '../Perk';
import { Badge } from '@/components/ui/badge';
import { PlusIcon } from 'lucide-react';

interface PropertyPerksProps {
  perks: string[];
  isMobile: boolean;
  shouldShowHoverEffects: boolean;
  featured: boolean;
}

export default function PropertyPerks({
  perks,
  isMobile,
  shouldShowHoverEffects,
  featured,
}: PropertyPerksProps) {
  if (isMobile || !perks || perks.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1 overflow-hidden min-h-[28px] relative">
      <div
        className={cn(
          'transition-all duration-300 ease-out',
          featured || shouldShowHoverEffects || isMobile
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 -translate-y-2'
        )}
      >
        <div className="flex gap-1 relative overflow-hidden">
          {perks.slice(0, 2).map((perk, index) => (
            <div
              key={perk}
              className={cn(
                'transition-all duration-300 ease-out',
                'inline-block',
                shouldShowHoverEffects || isMobile ? 'translate-y-0' : 'translate-y-2',
                `delay-${index * 75}`
              )}
            >
              <Perk type="default" perk={perk} />
            </div>
          ))}
          {perks.length > 2 && (
            <div
              className={cn(
                'transition-all duration-300 ease-out',
                'inline-block',
                shouldShowHoverEffects || isMobile ? 'translate-y-0' : 'translate-y-2',
                `delay-${3 * 75}`
              )}
            >
              <Badge variant={'outline'}>
                <span className="text-nowrap flex items-center justify-center gap-1">
                  <PlusIcon className="w-4 h-4" />
                  <span className="text-nowrap">{perks.length - 2} more</span>
                </span>
              </Badge>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
